import { Table } from 'antd';
import React from 'react';

interface SummaryTotalRowProps {
  getTotalPriceWithAdition: () => number;
  getTotalAchizitionPrice: () => number;
}

const SummaryTotalRow: React.FC<SummaryTotalRowProps> = ({ getTotalPriceWithAdition, getTotalAchizitionPrice }) => {
  return (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}>
        <strong>Total:</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1} />
      <Table.Summary.Cell index={2} />
      <Table.Summary.Cell index={3} />
      <Table.Summary.Cell index={4} />
      <Table.Summary.Cell index={5} />
      <Table.Summary.Cell index={6} />
      <Table.Summary.Cell index={7}>
        <strong>{getTotalAchizitionPrice()} Ron</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={8}>
        <strong>{getTotalPriceWithAdition()} Ron</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={9} />
      <Table.Summary.Cell index={10} />
    </Table.Summary.Row>
  );
};

export default SummaryTotalRow;
